AGADash.Pie = (function () {

    var defaultConfig = {
        "language": "pt",
        "groupedDescription": "Outros (sem detalhes)",
        "groupedTitle": "Outros (sem detalhes)",
        "type": "pie",
        "theme": "light",
        "valueField": "VALUE",
        "titleField": "TITLE",
        "outlineAlpha": 0.4,
        "depth3D": 7,
        "pullOutOnlyOne": true,
        "angle": 30,
        "decimalSeparator": ",",
        "thousandsSeparator": ".",
        "export": AGADash.Charts.getExportSettings()
    };
    
    var buildDataset = function (data) {
        var dataset = [];
        var keyIgnored = [data.Dimensions[0], data.Facts[0]];
        for (var i = 0; i < data.Values.length; i++) {
            var record = AGADash.Common.getRecord(data, i);
            var row = {};
            row["TITLE"] = record[data.Dimensions[0]];
            row["VALUE"] = record[data.Facts[0]];
            row["KEY"] = AGADash.Common.getDetailKey(data, i, keyIgnored);
            dataset.push(row);
        }
        return dataset;
    };

    var sliceInHandler = function (e) {
        $(e.chart.div).attr("currentkey", "");
        AGADash.Panel.clearDetails(e.chart.div);
    };

    var sliceOutHandler = function (e) {
        var key = e.dataItem.dataContext["KEY"];
        var current = $(e.chart.div).attr("currentkey");
        if (key === current)
            return;
        if (key) {
            $(e.chart.div).attr("currentkey", key);
            AGADash.Panel.loadDetails(e.chart.div, key);
        }
    };

    var invokeBeforeLoad = function (beforeLoadArgs, def) {
        // Executar evento beforeload
        AGADash.Events.invoke("beforeload", beforeLoadArgs.uid, function () {
            return $.extend({ "config": def }, beforeLoadArgs);
        });
    };

    var invokeAfterLoad = function (afterLoadArgs, chart) {
        // Evento afterload
        AGADash.Events.invoke("afterload", afterLoadArgs.uid, function () {
            return $.extend({ "chart": chart }, afterLoadArgs);
        });
    };

    var render = function(body, data) {
        var def = $.extend({}, defaultConfig);
        $(body).addClass("dash-pie-placeholder");

        // Build data set
        var dataset = buildDataset(data);
        def["dataProvider"] = dataset;

        // balloon
        var dataField = data.Facts[0];
        var dataInfo = AGADash.Common.getFormatInfo(data, dataField);
        var balloonFunc = function(dataItem) {
            var ballonText = dataItem.title +
                '<br><span style="font-size:14px"><b>' +
                AGADash.Common.Formatter.formatByInfo(dataInfo, dataItem.value) +
                "</b> (" +
                AGADash.Common.Formatter.formatNumber(dataItem.percents, 2) +
                "%)</span>";
            return ballonText;
        };
        def["balloonFunction"] = balloonFunc;
        def["precision"] = AGADash.Common.Formatter.getPrecision(dataInfo.Format);

        // legendas
        var legend = AGADash.Charts.getLegend(data);
        if (legend)
            def["legend"] = legend;

        // rótulo
        def["labelText"] = AGADash.Charts.getLabelText(data);

        // Verifica se é Donut
        if (data.Config && data.Config.indexOf(".donut.") >= 0) {
            def["innerRadius"] = "50%";
        }

        var placeHolder = $(body).attr("id");

        var baseEventArgument = AGADash.Events.getBaseEventArguments(body);
        invokeBeforeLoad(baseEventArgument, def);

        var chart = AmCharts.makeChart(placeHolder, def);

        invokeAfterLoad(baseEventArgument, chart);

        // Atrubuir eventos
        chart.addListener("pullOutSlice", sliceOutHandler);
        chart.addListener("pullInSlice", sliceInHandler);
    };

    return {
        render: render


    };

})();

AGADash.Repository.register(101, AGADash.Pie);
